import React from 'react';
import { TOOLTIP_POSITION_BOTTOM } from '../../../../utils/dom-utils';
import ToolTip from '../../../Shared/ToolTip/ToolTip';
import styles from '../../../Shared/APPText/APPText.module.scss';

const RothConversionNote = ({ isSalesforceRep, customerWebViewEnabled }) => {
  return (
    <section className="roth-conv-div">
      <h3>Important Note</h3>
      <div>
        A Roth conversion is a tax reportable event that could result in tax
        implications. Amounts converted are generally taxable in the year of the
        conversion. Please see your tax professional regarding your specific
        situation.
      </div>
      <div>
        If you are intending on{' '}
        <ToolTip
          theme="dark"
          callerText={<a> recharacterizing </a>}
          header={<h4>Recharacterizing</h4>}
          message="IRA recharacterization is the changing of a Traditional IRA contribution to a Roth IRA contribution or a Roth IRA contribution to a Traditional IRA contribution. Recharacterize your IRA contribution by your tax filing deadline, including extensions."
          placement={TOOLTIP_POSITION_BOTTOM}
        />{' '}
        an IRA contribution, do not use this conversion process; use the{' '}
        {!customerWebViewEnabled && isSalesforceRep ? (
          <span>Recharacterization Form</span>
        ) : (
          <a
            href="https://individual.troweprice.com/staticFiles/Retail/Shared/PDFs/IRAReChar.pdf"
            target="_blank"
            rel="noreferrer"
          >
            Recharacterization Form
          </a>
        )}
        .
      </div>
      <div>
        Even though you may be able to convert to a Roth IRA, you may not be
        eligible to contribute to a Roth IRA. If you are not sure whether you
        are eligible to contribute to a Roth IRA you may want to review the
        contribution
        <a
          href="https://individual.troweprice.com/public/Retail/Retirement/IRA/Roth-IRA?src=RothTradTool#contribute"
          target="_blank"
          rel="noreferrer"
        >
          {' '}
          income limitations{' '}
        </a>{' '}
        before proceeding.
      </div>
      <div>
        ActivePlus Portfolio<sup className={styles.sup}>®</sup> and Retirement
        Advisory Service accounts are not eligible to be converted online.
        Please
        <a
          href="https://www.troweprice.com/personal-investing/help/contact/index.html"
          target="_blank"
          rel="noreferrer"
        >
          {' '}
          contact us
        </a>{' '}
        if you would like to convert either of these account types.
      </div>
      <div>
        Convert your existing Brokerage T. Rowe Price IRA to a Brokerage Roth
        IRA using the{' '}
        <a
          href="https://www.troweprice.com/content/dam/iinvestor/Forms/IRAConvTrans.pdf"
          target="_blank"
          rel="noreferrer"
        >
          IRA Roth Conversion form (PDF)
        </a>
        , or{' '}
        <a
          href="https://www.troweprice.com/personal-investing/help/contact/index.html"
          target="_blank"
          rel="noreferrer"
        >
          contact us
        </a>{' '}
        to complete the form electronically.
        <p>
          Looking to convert your SEP-IRA or SIMPLE-IRA to a Roth IRA?{' '}
          <a
            href="https://www.troweprice.com/personal-investing/help/contact/index.html"
            target="_blank"
            rel="noreferrer"
          >
            Speak to a Small Business Retirement Specialist
          </a>{' '}
          for assistance.
        </p>
      </div>
    </section>
  );
};

export default RothConversionNote;
